import React, { PropsWithChildren, useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';

import { createGenericContext } from '../generateContext';

type ContextInterface = {
  isVisible?: boolean;
  footerRef?: (node?: Element | null | undefined) => void;
};

const [useFooterContext, FooterContextProvider] =
  createGenericContext<ContextInterface>();

const IsVisibleFooterProvider = (props: PropsWithChildren) => {
  const [isVisible, setIsVisible] = useState(false);

  const { ref: footerRef, inView } = useInView({
    threshold: 0.15,
    fallbackInView: true,
  });
  useEffect(() => {
    setIsVisible(inView);
  }, [inView]);

  return (
    <FooterContextProvider
      value={{
        isVisible,
        footerRef,
      }}
    >
      {props.children}
    </FooterContextProvider>
  );
};
export { useFooterContext, IsVisibleFooterProvider };
